import { render, staticRenderFns } from "./ooo-indicator.vue?vue&type=template&id=08a65d5e"
import script from "./ooo-indicator.vue?vue&type=script&lang=js"
export * from "./ooo-indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports